import React, { useState } from 'react';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Delete, Edit } from '@mui/icons-material';
import FuseLoading from '@fuse/core/FuseLoading';
import SimpleDialog from '@fuse/core/SimpleDialog';
import {
  useGetAllProjectTypesQuery,
  useDeleteProjectTypeMutation,
} from 'src/app/services/projectTagsTypesApi';
import useMessage from 'src/app/hooks/useMessage';
import handleError from '@fuse/core/errorHandler';
import ProjectTypesForm from './ProjectTypesForm';

const ProjectTypes = () => {
  const { t, i18n } = useTranslation('translations');
  const [currentProjectType, setCurrentProjectTypeId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { data: projectTypes = [], refetch, isLoading } = useGetAllProjectTypesQuery();
  const [deleteCategory] = useDeleteProjectTypeMutation();
  const { showMessage } = useMessage();

  const showAddDialog = () => {
    setCurrentProjectTypeId(null);
    setIsDialogOpen(true);
  };

  const showEditDialog = (data) => {
    setCurrentProjectTypeId(data);
    setIsDialogOpen(true);
  };

  const handleDelete = (id) => {
    deleteCategory(id)
      .unwrap()
      .then(() => {
        showMessage({ message: t('SuccessfullyDeleted'), variant: 'success' });
      })
      .catch(handleError);
  };

  return (
    <div style={{ display: 'grid' }}>
      {isLoading ? (
        <FuseLoading />
      ) : (
        <TableContainer>
          <div className="h-[40px] flex flex-row justify-between items-center dark:bg-dark">
            <h2 className="ml-5">{t('ProjectTypes')}</h2>
            <Button
              className="mx-8"
              size="small"
              variant="outlined"
              color="secondary"
              onClick={showAddDialog}
            >
              <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
              <span className="mx-8">{t('Add')}</span>
            </Button>
          </div>
          <Table style={{ overflow: 'auto' }}>
            <TableBody className="overflow-y-auto">
              {projectTypes?.map((item) => (
                <TableRow key={item.id} className="bg-white hover:bg-grey-200 dark:bg-dark">
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    <div className="flex justify-end">
                      <IconButton
                        edge="end"
                        aria-label="edit"
                        className="mr-5"
                        color="info"
                        onClick={() => showEditDialog(item)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        className="mr-5"
                        color="error"
                        onClick={() => handleDelete(item.id)}
                      >
                        <Delete />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <SimpleDialog
        title={currentProjectType ? t('Edit') : t('Add')}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      >
        <ProjectTypesForm
          projectType={currentProjectType}
          refetch={refetch}
          onClose={() => setIsDialogOpen(false)}
          isEdit={!!currentProjectType}
        />
      </SimpleDialog>
    </div>
  );
};

export default ProjectTypes;
